module.exports = __webpack_public_path__ + "assets/e9f099bba6870edf324c48ac4b237df2.svg";